module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_c('em', [_vm._v("For Damon")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some very generous people helped me with this book. Many thanks to Rebecca Allswang, Lisl Hampton, Kelly Evans Pfeifer, and Sara Sens for their meticulous and enthusiastic recipe testing. Thanks also to my tireless cadre of tasters: Michael and Chris Ferreira; Damon, Rebecca, and Jackie Allswang; Cliff Ingham; and Michael Goorjian. I am especially indebted to Kate Washington, for sharing her unique ability to be both precise and inspired, and above all to Debbie Hughes, for keeping the hot lines open no matter how often I call.")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image2"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image2",
      "height": "100%",
      "src": "images/img-6.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76785229","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003dedication.vue
// module id = 63
// module chunks = 0